import { USE_API } from '../../config/env';
import { getFaqs } from '../../services/faqService';
import * as types from '../types/faqTypes';

export const getFaqsAction = (params = {}) => async (dispatch) => {
  if (!USE_API) return [];
  dispatch({ type: types.GET_FAQS_REQUEST });
  try {
    const list = await getFaqs(params);
    dispatch({ type: types.GET_FAQS_SUCCESS, payload: list });
    return list;
  } catch (e) {
    dispatch({
      type: types.GET_FAQS_FAILURE,
      payload: e?.response?.data?.message || e?.message || 'Failed to load FAQs',
    });
    return [];
  }
};
